import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

import { AppSettingsService } from '~/core/services/appsettings.service';
import { AppConfigService } from '~/core/services/appconfig.service';
import { GraphService } from '~/core/services/graph.service';
import { AppSettings } from '~/core/models/appsettings';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private router: Router,
        private appSettingsService: AppSettingsService,
        private appConfigService: AppConfigService,
        private graphService: GraphService,
        private msalService: MsalService,
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {

            // Step 1: Check if user is authenticated via MSAL
            const accounts = this.msalService.instance.getAllAccounts();

            if (!accounts || accounts.length === 0) {
                if (!sessionStorage.getItem('_redirect')) {
                    sessionStorage.setItem('_redirect', state.url);
                }
                await this.router.navigate(['/auth']);
                return false;
            }


            // Step 2: Check AD group membership (OPTIONAL - only if object_id is configured)
            const requiredGroupObjectId = this.appConfigService.getConfig().object_id;
            if (requiredGroupObjectId && requiredGroupObjectId.trim() !== '') {
                try {
                    const isMember = await this.graphService.isUserInRequiredGroup(requiredGroupObjectId);
                    if (!isMember) {
                        await this.router.navigate(['/access'], { state: { type: 'application' } });
                        return false;
                    }
                } catch (err) {
                    // Group membership check failed - allow through as backend will enforce authorization
                    // This prevents blocking users due to temporary Graph API issues
                }
            } 

            return true;
        } catch (err) {
            await this.router.navigate(['/access'], { state: { type: 'page' } });
            return false;
        }
    }
}
 